import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's145g-s145m01',
    templateUrl: './s145g-s145m01.component.html'
})
export class S145gS145m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    trnnbr: any = {'value': '____'};
    legnbr: any = {'value': '__'};
    riders1: any = {'value': '____'};
    riders2: any = {'value': '____'};
    msgln: any = {};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'trnnbr', 'legnbr', 'riders1', 'riders2', 'msgln'];
    public LINES: number[] = [1, 2, 3, 4, 6, 7, 9, 11, 12, 14, 15, 22, 24];

    ngAfterViewInit(): void {
    }
}
